// src/features/dashboard/components/RecentTicketsList.tsx
import { ArrowUpLeft } from 'lucide-react';
import { GlassCard } from '../../../app/components/ui/GlassCard';
import { ListItemSkeleton } from './ui/Skeleton';
import { PriorityBadge, TicketStatusDot } from './PriorityBadge';
import type { RecentTicket } from '../types/dashboard.types';

interface RecentTicketsListProps {
  tickets: RecentTicket[];
  isInitialLoading: boolean;
}

export function RecentTicketsList({ tickets, isInitialLoading }: RecentTicketsListProps) {
  return (
    <GlassCard className="vania-tickets-card" data-animate="fade-in">
      <div className="vania-panel-header">
        <div className="flex items-center gap-2">
          <h3 className="vania-panel-title">تیکت‌های اخیر</h3>
          {!isInitialLoading && <span className="vania-panel-count">{tickets.length}</span>}
        </div>
        <button type="button" className="vania-link-button">
          مشاهده همه
          <ArrowUpLeft size={14} strokeWidth={2.5} />
        </button>
      </div>

      <div className="divide-y divide-[var(--vania-border-glass,rgba(255,255,255,0.06))]">
        {isInitialLoading
          ? Array.from({ length: 4 }).map((_, i) => <ListItemSkeleton key={i} />)
          : tickets.map((ticket) => (
              <div key={ticket.id} className="vania-ticket-row flex items-center gap-3 py-3.5">
                <img
                  src={ticket.customerAvatarUrl}
                  alt={ticket.customerName}
                  className="vania-ticket-avatar h-9 w-9 rounded-full shrink-0 bg-[var(--vania-surface-2,rgba(255,255,255,0.04))]"
                />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between gap-2">
                    <span className="text-sm font-medium text-[var(--vania-text-primary,#f5f6fa)] truncate">
                      {ticket.customerName}
                    </span>
                    <PriorityBadge priority={ticket.priority} />
                  </div>
                  <p className="text-xs text-[var(--vania-text-secondary,#a3aab8)] truncate mt-0.5">
                    {ticket.subject}
                  </p>
                  <div className="flex items-center justify-between mt-1.5">
                    <TicketStatusDot status={ticket.status} />
                    <span className="text-[11px] text-[var(--vania-text-tertiary,#6b7280)]">
                      {ticket.lastReply}
                    </span>
                  </div>
                </div>
              </div>
            ))}
      </div>
    </GlassCard>
  );
}
